import React, { useEffect, useRef, useState } from 'react';
import Footer from '../components/Footer';
import Header from '../components/Header';
import Swal from 'sweetalert2';
import "../scss/card.css"
import { generateAxiosInstance } from '../hooks/useAuthorizedRequest';
import { generateAxiosInstanceCommon } from '../hooks/useAuthorizedReuestCommon';
import { useNavigate } from 'react-router-dom';

const ViewPdfBook = () => {
    const authorizedAxios = generateAxiosInstance()
    const authorizedAxiosCommon = generateAxiosInstanceCommon()
    const initialFormState = {
        syllabusStructureMasterId: '',
        lessonMasterId: '',
        topicMasterId: '',
        subTopicId: '',
        subTopicName: '',
        details: '',
        subjectMasterId: ''
    }
    const [syllabusList, setSyllabusList] = useState([])
    const [lessonList, setLessonList] = useState([])
    const [topicList, setTopicList] = useState([])
    const [subTopicViewtopicList, setSubTopicViewtopicList] = useState([])
    const [subtopicList, setSubtopicList] = useState([])
    const [subtopicData, setSubtopicData] = useState(initialFormState)
    const [subjectList, setSubjectList] = useState([])
    const [showSummery, setShowSummery] = useState(false);
    const [currentIndex, setCurrentIndex] = useState(0);
    const navigate = useNavigate();
    const handleNavigate = (route) => {
        navigate(route);
    };

    useEffect(() => {
        getSyllabusList();
        getSubtopicList();
    }, []);

    useEffect(() => {
        if (subtopicData.syllabusStructureMasterId !== '' && subtopicData.subjectMasterId !== '') {
            let apiUrl = '/get-sub-topic-master-list?';
            if (subtopicData.syllabusStructureMasterId) {
                apiUrl += `syllabusStructureId=${subtopicData.syllabusStructureMasterId}&`;
            }
            if (subtopicData.subjectMasterId) {
                apiUrl += `subjectMasterId=${subtopicData.subjectMasterId}&`
            }
            if (subtopicData.lessonMasterId) {
                apiUrl += `lessonId=${subtopicData.lessonMasterId}&`;
            }
            if (subtopicData.topicMasterId) {
                apiUrl += `topicId=${subtopicData.topicMasterId}&`;
            }
            if (subtopicData.subTopicId) {
                apiUrl += `subTopicId=${subtopicData.subTopicId}&`;
            }
            apiUrl = apiUrl.replace(/&$/, '');
            authorizedAxios && authorizedAxios.get(apiUrl)
                .then(response => {
                    setSubtopicList(response.data.result);
                })
                .catch(error => {
                    setSubtopicList(error?.response?.data.result);
                    const errorMsg = error?.response?.data?.message || 'Something went wrong!';
                    console.error('Error fetching data:', errorMsg);
                });
        }
    }, [subtopicData]);

    const getSyllabusList = () => {
        const apiUrlForSyllabus = `/get-all-syllabus-structure`;
        authorizedAxiosCommon && authorizedAxiosCommon.get(apiUrlForSyllabus)
            .then(response => {
                setSyllabusList(response.data.result)
            })
            .catch(error => {
                const errorMsg = error?.response?.data?.message || 'Something went wrong!';
                console.error('Error fetching data:', errorMsg);
            });
    }

    const getSubtopicList = () => {
        const apiUrl = `/get-sub-topic-master-list`;
        authorizedAxios && authorizedAxios.get(apiUrl)
            .then(response => {
                setSubtopicList(response.data.result)
            })
            .catch(error => {
                const errorMsg = error?.response?.data?.message || 'Something went wrong!';
                console.error('Error fetching data:', errorMsg);
            });
    }

    const handleInputChange = (e) => {
        setSubtopicData((prevData) => {
            return {
                ...prevData,
                [e.target.name]: e.target.value
            }
        })
    }

    const handleSyllabusChange = (e) => {
        setSubtopicData((prevData) => {
            return {
                ...prevData,
                [e.target.name]: e.target.value,
                lessonMasterId: '',
                topicMasterId: '',
                subTopicId: '',
                subjectMasterId: ''
            }
        })

        setLessonList([])
        setTopicList([])
        setSubTopicViewtopicList([])

        const apiUrl2 = `/syllabus-structure-wise-subjects?id=${e.target.value}`;
        authorizedAxios && authorizedAxios.get(apiUrl2)
            .then(response => {
                setSubjectList(response.data.result)
            })
            .catch(error => {
                const errorMsg = error?.response?.data?.message || 'Something went wrong!';
                console.error('Error fetching data:', errorMsg);
            });
    }

    const handleSubjectChange = (e) => {
        setSubtopicData((prevData) => {
            return {
                ...prevData,
                [e.target.name]: e.target.value,
                lessonMasterId: '',
                topicMasterId: '',
                subTopicId: '',
            }
        })

        setTopicList([])
        setSubTopicViewtopicList([])

        const apiUrl = `/subject-wise-lesson?syllabusStructureMasterId=${subtopicData.syllabusStructureMasterId}&subjectMasterId=${e.target.value}`;
        authorizedAxios && authorizedAxios.get(apiUrl)
            .then(response => {
                setLessonList(response.data.result)
            })
            .catch(error => {
                const errorMsg = error?.response?.data?.message || 'Something went wrong!';
                console.error('Error fetching data:', errorMsg);
            });
    }

    const handleLessonChange = (e) => {
        setSubtopicData((prevData) => {
            return {
                ...prevData,
                [e.target.name]: e.target.value,
                topicMasterId: '',
                subTopicId: ''
            }
        })
        setSubTopicViewtopicList([])

        const apiUrl = `/lesson-wise-topic?id=${e.target.value}`;
        authorizedAxios && authorizedAxios.get(apiUrl)
            .then(response => {
                setTopicList(response.data.result)
            })
            .catch(error => {
                const errorMsg = error?.response?.data?.message || 'Something went wrong!';
                console.error('Error fetching data:', errorMsg);
            });
    }

    const handleTopicChange = (e) => {
        setSubtopicData((prevData) => {
            return {
                ...prevData,
                [e.target.name]: e.target.value,
                subTopicId: ''
            }
        })
        const apiUrl = `/get-sub-topic-master-list?syllabusStructureId=${subtopicData.syllabusStructureMasterId}&subjectMasterId=${subtopicData.subjectMasterId}&lessonId=${subtopicData.lessonMasterId}&topicId=${e.target.value}`;
        authorizedAxios && authorizedAxios.get(apiUrl)
            .then(response => {
                setSubTopicViewtopicList(response.data.result)
            })
            .catch(error => {
                setSubTopicViewtopicList([])
                const errorMsg = error?.response?.data?.message || 'Something went wrong!';
                console.error('Error fetching data:', errorMsg);
            });
    }

    const handleNext = () => {
        if (currentIndex < subtopicList.length - 1) {
            setCurrentIndex(currentIndex + 1);
        }
    };

    const handlePrev = () => {
        if (currentIndex > 0) {
            setCurrentIndex(currentIndex - 1);
        }
    };

    useEffect(() => {
        setCurrentIndex(0)
    }, [subtopicData])


    const generatePDF = () => {
        let apiUrl = window.location.origin;
        if (subtopicData.syllabusStructureMasterId) {
            apiUrl += `/print?syType=A&SyllabusStructureMasterId=${subtopicData.syllabusStructureMasterId}&`;
        }
        if (subtopicData.subjectMasterId) {
            apiUrl += `SubjectMasterId=${subtopicData.subjectMasterId}&`
        }
        if (subtopicData.lessonMasterId) {
            apiUrl += `LessonMasterId=${subtopicData.lessonMasterId}&`;
        }
        if (subtopicData.topicMasterId) {
            apiUrl += `TopicMasterId=${subtopicData.topicMasterId}&`;
        }
        if (subtopicData.subTopicId) {
            apiUrl += `SubTopicId=${subtopicData.subTopicId}&`;
        }
        apiUrl = apiUrl.replace(/&$/, '');
        window.open(apiUrl, "_blank");
    };



    return (
        <>
            <div className="wrapper d-flex flex-column min-vh-100 bg-light">
                <Header />
                <div className="container-fluid">
                    <nav aria-label="breadcrumb">
                        <ol className="breadcrumb my-0 ms-2">
                            <li className="breadcrumb-item dashboard" onClick={() => handleNavigate('/dashboard')}>
                                <span>Dashboard</span>
                            </li>
                            <li className="breadcrumb-item active"><span>View Content Book</span></li>
                        </ol>
                    </nav>
                </div>
                <div className="container-lg">
                    <div className="row">
                        <div className="card border-info mx-auto mt-3">
                            <div className="card-content collpase show">
                                <div className="card-header" style={{ backgroundColor: '#3081D0', borderRadius: 0 }}>
                                    <h4 className="text-white"><b><span className="fa fa-file-o"></span><i class="fa fa-eye"></i> View Content Book</b></h4>
                                </div>
                                <div className="card-body">
                                    <div className="row">
                                        <div className="col-md-12">
                                            <div className="row">
                                                <div className="col-md-6">
                                                    <label for="inputPassword" className="col-form-label"><span style={{ color: "red" }}>*</span>Select Syllabus Structure :</label>
                                                    <select required class="form-select" aria-label="Default select example" name='syllabusStructureMasterId' onChange={handleSyllabusChange} value={subtopicData.syllabusStructureMasterId}>
                                                        <option selected value={''} disabled>Select Syllabus</option>
                                                        {
                                                            syllabusList?.map((syllabus) => {
                                                                return <option value={syllabus.id}>{syllabus?.syllabusStructureName}</option>
                                                            })
                                                        }
                                                    </select>
                                                </div>
                                                <div className="col-md-6">
                                                    <label for="inputPassword" className="col-form-label"><span style={{ color: "red" }}>*</span>Select Subject :</label>
                                                    <select required class="form-select" aria-label="Default select example" name='subjectMasterId' onChange={handleSubjectChange} value={subtopicData.subjectMasterId}>
                                                        <option selected value={''} disabled>Select Subject</option>
                                                        {
                                                            subjectList?.map((syllabus) => {
                                                                return <option value={syllabus.subjectMasterDetails.id}>{syllabus.subjectMasterDetails.subjectName}</option>
                                                            })
                                                        }
                                                    </select>
                                                </div>
                                                <div className="col-md-6">
                                                    <label for="inputPassword" className="col-form-label">Select Lesson :</label>
                                                    <select required class="form-select" aria-label="Default select example" name='lessonMasterId' onChange={handleLessonChange} value={subtopicData.lessonMasterId}>
                                                        <option selected value={''} disabled>Select Lesson</option>
                                                        {
                                                            lessonList?.map((lesson) => {
                                                                return <option value={lesson.id}>{lesson.lessonName}</option>
                                                            })
                                                        }
                                                    </select>

                                                </div>
                                                <div className="col-md-6">
                                                    <label for="inputPassword" className="col-form-label">Select Topic :</label>
                                                    <select required class="form-select" aria-label="Default select example" name='topicMasterId' onChange={handleTopicChange} value={subtopicData.topicMasterId}>
                                                        <option selected value={''} disabled>Select Topic</option>
                                                        {
                                                            topicList?.map((topic) => {
                                                                return <option value={topic.id}>{topic.topicName}</option>
                                                            })
                                                        }
                                                    </select>
                                                </div>

                                                <div className="col-md-6">
                                                    <label for="inputPassword" className="col-form-label">Select Sub Topic :</label>
                                                    <select required class="form-select" aria-label="Default select example" name='subTopicId' onChange={handleInputChange} value={subtopicData.subTopicId}>
                                                        <option selected value={''} disabled>Select Sub Topic</option>
                                                        {
                                                            subTopicViewtopicList?.map((topic) => {
                                                                return <option value={topic.id}>{topic.subTopicName}</option>
                                                            })
                                                        }
                                                    </select>
                                                </div>
                                            </div>

                                            <div className="col-md-12 mt-3 mb-1" style={{ textAlign: 'center' }}>
                                                <button className="btn btn-outline-danger delete_icon" type="button" onClick={() => { setSubtopicData(initialFormState); setSubtopicList([]) }}>Reset</button>
                                            </div>

                                            {subtopicList.length !== 0 &&
                                                <div className="content_book_wraper">
                                                    {subtopicList.length !== 0 && <span className="text-blue" onClick={() => generatePDF(subtopicList)} ><b><span className="fa fa-file-o"></span><button className='print-btn btn btn-info'>Print<i class="fa fa-print"></i></button></b></span>}
                                                    {/* {subtopicList.length !== 0 && (<span className="text-blue" onClick={() => {
                                                        setShowSummery(!showSummery)
                                                    }} ><b><span className="fa fa-file-o"></span><button className='print-btn btn btn-info'>Summary<i class="fa fa-list-alt"></i></button></b></span>)} */}
                                                    <div class="content_book_wrap">
                                                        <div className="row">

                                                            <div className="book">
                                                                <div className='lesson_area'>
                                                                    <div className='lesson_no'>
                                                                        <div className='info'>
                                                                            <span className='capt'>Class:</span>
                                                                            <span className='value'>{subtopicList[currentIndex].subTopicMasterSyllabusStructureMasterDetails.gradeMasterDetails.gradeName}</span>
                                                                        </div>
                                                                        <div className='info'>
                                                                            <span className='capt'>Subject:</span>
                                                                            <span className='value'>{subtopicList[currentIndex].subjectMasterDetails.subjectName}</span>
                                                                        </div>
                                                                    </div>

                                                                    <div className='chapter_name'>
                                                                        <div className='info'>
                                                                            <span className='capt'>Chapter Name: </span>
                                                                            <span className='value'>{subtopicList[currentIndex].subTopicMasterLessonMasterDetails.lessonName}</span>
                                                                        </div>
                                                                    </div>
                                                                </div>
                                                                <div className="page" dangerouslySetInnerHTML={{ __html: `<style>.ckContent img{max-width:100% !important; height: auto !important}</style><div class="ck-content">${subtopicList[currentIndex]?.details}</div>` }} ></div>

                                                                <div className='nav_btn_progress'>
                                                                    <button className="btn btn-outline-danger view_icon" type="button" style={{ marginRight: '0' }} disabled={currentIndex === 0} onClick={() => { handlePrev() }}><i class="fa fa-chevron-left"></i></button>

                                                                    <div class="progress_bar_block">
                                                                        <span className='read_progress' style={{ width: `${((currentIndex + 1) / subtopicList.length) * 100}%` }}></span>
                                                                    </div>
                                                                    <button className="btn btn-outline-danger view_icon" type="button" style={{ marginRight: '0' }} disabled={currentIndex === subtopicList.length - 1} onClick={() => { handleNext() }}> <i class="fa fa-chevron-right"></i> </button>
                                                                </div>

                                                                <div className='page_no_area'>
                                                                    <div className='page_no'>
                                                                        <span>{currentIndex + 1} of {subtopicList.length}</span>
                                                                    </div>
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                            }
                                            
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <Footer />
        </>
    )
};

export default ViewPdfBook;